import { AssignmentAttributes, NdGroup } from '~/models/NdGroup';

export default class NdGroupService {
  public static async assignToTracker(trackerId: number, hash: string) {
    return await (await this.getApiClient()).assignToTracker({ trackerId, hash } as AssignmentAttributes);
  }

  public static async unassignFromTracker(trackerId: number, hash: string) {
    return await (await this.getApiClient()).unassignFromTracker({ trackerId, hash } as AssignmentAttributes);
  }

  public static async findAll(): Promise<Array<NdGroup>> {
    return await (await this.getApiClient()).provideGroups();
  }

  public static async findAssignedToTracker(trackerId: number): Promise<Array<NdGroup>> {
    return await (await this.getApiClient()).provideAssignedToTracker(trackerId);
  }

  public static async isSynchronized(hash: string, isDev: boolean): Promise<boolean> {
    if (isDev) {
      return true;
    }
    const ndGroups: NdGroup[] = await (await this.getApiClient()).provideGroups();
    return ndGroups.map((ndGroup: NdGroup) => ndGroup.hash).includes(hash);
  }

  private static async getApiClient() {
    //TODO: fix circular dependency [NdGroupApiClient <-> User]
    const apiClientClass = await import('~/apiClients/NdGroupApiClient');
    const NdGroupApiClient = apiClientClass.default;
    return new NdGroupApiClient();
  }
}
